// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3070 ? "8012d7e2" : chunkId) + "." + {"3070":"b033b33334dbca32","9584":"a7e57cff53ef48e5"}[chunkId] + ".js";
};